<template>
  <q-layout view="hHh lpR fFf" style="display: grid">
    <q-page-container :style="$q.screen.width < 485 ? `` : `margin: auto`">
      <q-card
        flat
        bordered
        :class="$q.screen.width < 485 ? `my-card-mobile` : `my-card`"
      >
        <q-card-section>
          <div class="row justify-center">
            <q-img
              basic
              v-if="$q.screen.width < 485"
              contain
              width="50px"
              :src="require('@/assets/logo-villa-mobile.svg')"
            />
            <q-img
              basic
              v-else
              contain
              width="100px"
              :src="require('@/assets/logo-villa-mobile.svg')"
            />
          </div>
          <div class="row justify-center">
            <div class="text-h6">Villa market</div>
          </div>
        </q-card-section>

        <!-- <q-separator inset /> -->
        <template v-if="sessionExpire">
          <q-card-section
            :style="
              $q.screen.width < 485 ? `min-height: 75vh` : `min-height: 100px`
            "
          >
            <div class="row justify-center">
              <div class="text-h6">Session expired</div>
            </div>
          </q-card-section>
        </template>
        <template v-else-if="isRequestToPayError">
          <q-card-section
            :style="
              $q.screen.width < 485 ? `min-height: 75vh` : `min-height: 100px`
            "
          >
            <div class="row justify-center">
              <div
                class=""
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  text-align: center;
                "
              >
                <div class="text-h6">Something went wrong</div>
                <p>Please try again later.</p>
              </div>
            </div>
          </q-card-section>
        </template>
        <template v-else-if="loading">
          <q-card-section>
            <div class="row justify-center">
              <q-spinner size="lg" color="primary" />
            </div>
          </q-card-section>
        </template>
        <template v-else>
          <q-card-section>
            <div class="text-subtitle2">Order {{ order.orderId }}</div>
            <div class="text-subtitle2">Shipping to</div>
            <div class="text-subtitle2 no-bold text-grey-8">
              {{ formatedAddress }}
            </div>
            <div class="text-subtitle2">Order summary</div>
            <div
              class="text-subtitle2 row justify-between no-bold"
              v-for="(product, index) in order.productList"
              :key="index"
            >
              <div class="text-grey-8">
                {{ product.productName }} x{{ product.quantity }}
              </div>
              <div class="text-primary">฿ {{ product.price }}</div>
            </div>
          </q-card-section>

          <q-card-section>
            <div class="row full-width justify-between">
              <div class="text-subtitle2 no-bold">Sub total</div>
              <div class="text-subtitle2 no-bold">
                {{ order.subTotal }}
              </div>
            </div>
            <div
              v-if="order.deliveryFee > 0"
              class="row full-width justify-between"
            >
              <div class="text-subtitle2 no-bold">Total delivery fee</div>
              <div class="text-subtitle2 no-bold">
                {{ order.deliveryFee | positiveNumber }}
              </div>
            </div>
            <div
              v-if="order.expressShippingCost > 0"
              class="row full-width justify-between"
            >
              <div class="text-subtitle2 no-bold">Express fee</div>
              <div class="text-subtitle2 no-bold">
                {{ order.expressShippingCost | positiveNumber }}
              </div>
            </div>
            <div v-if="order.totalDiscount > 0" class="q-my-xs">
              <div
                v-if="order.totalDiscount > 0"
                class="row full-width justify-between"
              >
                <div class="text-subtitle2 no-bold">Total discount</div>
                <div class="text-subtitle2 no-bold text-red">
                  {{ order.totalDiscount | nagativeNumber }}
                </div>
              </div>
              <div
                v-if="promotionalDiscount > 0"
                class="row full-width justify-between q-px-md text-grey-8"
              >
                <div class="text-caption no-bold">Promotional discount</div>
                <div class="text-caption no-bold text-red">
                  {{ promotionalDiscount | nagativeNumber }}
                </div>
              </div>
              <div
                v-if="order.voucherDiscount > 0"
                class="row full-width justify-between q-px-md text-grey-8"
              >
                <div class="text-caption no-bold">Voucher discount</div>
                <div class="text-caption no-bold text-red">
                  {{ order.voucherDiscount | nagativeNumber }}
                </div>
              </div>
            </div>
            <div class="row full-width justify-between">
              <div class="text-subtitle1 text-primary">Total</div>
              <div class="text-subtitle1 text-primary">
                ฿ {{ order.grandTotal }}
              </div>
            </div>
          </q-card-section>

          <q-separator inset />

          <q-card-section>
            <div class="text-h5">Choose payment method</div>
            <q-list bordered separator>
              <q-item
                dense
                tag="label"
                v-for="(item, index) in paymentMethods"
                :key="index"
                clickable
                v-ripple
              >
                <q-item-section avatar>
                  <q-radio v-model="selectedPaymentMethod" :val="item.value" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>{{ item.title }}</q-item-label>
                  <!-- <div>
                                        Text
                                    </div> -->
                </q-item-section>
              </q-item>
            </q-list>
          </q-card-section>

          <q-separator inset />

          <q-card-section>
            <q-btn
              unelevated
              no-caps
              no-wrap
              :loading="paymentLoading"
              class="full-width"
              block
              color="primary"
              label="Continue"
              @click="onContinue"
            >
              <template v-if="loading" v-slot:loading>
                <q-spinner class="on-left" />
              </template>
            </q-btn>
          </q-card-section>
        </template>

        <q-card-section>
          <span class="text-subtitle2">
            <a href="https://shop.villamarket.com/terms">
              Terms and conditions
            </a>
            and
            <a href="https://shop.villamarket.com/privacy-policy">
              Privacy Policy
            </a>
          </span>
        </q-card-section>
      </q-card>
    </q-page-container>
    <component ref="payment" :is="paymentComponents[selectedPaymentMethod]" />
  </q-layout>
  <!-- <div class="vplus-info" v-if="selectedPaymentMethod === `Vplus Wallet`">
          <q-card-section>
            <div class="text-h5">VPlus Wallet</div>
            <div class="column">
              <q-input
                dense
                square
                outlined
                label="Phone number"
                v-model="vplusData.phoneNumber"
                type="number"
                :maxlength="10"
                error-message="Please enter VPlus phone number."
                :error="!isValidPhone"
              ></q-input>
              <q-input
                dense
                square
                outlined
                :maxlength="6"
                label="Member ID"
                v-model="vplusData.memberId"
                error-message="Please enter VPlus member ID."
                :error="!isValidID"
              ></q-input>
            </div>
          </q-card-section>

          <q-separator inset />
        </div>

        <q-card-section>
          <q-btn
            unelevated
            no-caps
            no-wrap
            :loading="loading"
            class="full-width"
            block
            color="primary"
            label="Continue"
            @click="onContinue"
          >
            <template v-if="loading" v-slot:loading>
              <q-spinner class="on-left" />
            </template>
          </q-btn>
        </q-card-section>

        <q-card-section>
          <span class="text-subtitle2">
            <a href="https://shop.villamarket.com/terms">
              Terms and conditions
            </a>
            and
            <a href="https://shop.villamarket.com/privacy-policy">
              Privacy Policy
            </a>
          </span>
        </q-card-section>
      </q-card>
    </q-page-container>
    <q-dialog persistent v-model="dialogVplusWallet.show">
      <DialogAlert
        :message="dialogVplusWallet.message"
        :submessage="dialogVplusWallet.submessage"
        right-btn="Close"
        @rightClick="onCloseDialogVplusWallet"
      >
      </DialogAlert>
    </q-dialog>
    <component ref="payment" :is="paymentComponents[selectedPaymentMethod]" />
  </q-layout> -->
</template>

<script>
// import { mapGetters } from "vuex";
// import axios from "axios";
import API from "@aws-amplify/api";
// import Auth from "@aws-amplify/auth";
import PayVplus from "@/ui/components/PayVplus.vue";
import * as Sentry from "@sentry/browser";

const paymentComponents = {
  "Credit/Debit card": "CreditCardForm",
  Amex: "CreditCardForm",
  Other: "CreditCardForm",
  "Vplus Wallet": "RequestToPayForm",
};

export default {
  name: "Pay",
  components: {
    CreditCardForm: () => import("@/ui/components/CreditCardForm.vue"),
    RequestToPayForm: () => import("@/ui/components/RequestToPayForm.vue"),
  },
  data() {
    return {
      sessionExpire: false,
      loading: true,
      isRequestToPayError: false,
      paymentLoading: false,
      memberId: null,
      phone: null,
      paymentComponents,
      paymentMethods: [
        {
          title: "Credit/Debit card",
          value: "Credit/Debit card",
        },
        {
          title: "Amex",
          value: "Amex",
        },
        {
          title: "Vplus Wallet",
          value: "Vplus Wallet",
        },
        {
          title: "QR Payment",
          value: "Other",
        },
      ],
      selectedPaymentMethod: null,
      order: {
        orderId: "123",
        shipping: {
          address: "168/22 mo. 5 Prakret Nonthaburi 11120",
        },
        productList: [
          {
            productName: "Turkey",
            price: 199,
            quantity: 3,
          },
          {
            productName: "Crushed Olives Naples Style",
            price: 140,
            quantity: 1,
          },
          {
            productName: "Spicy Red Snow Crab Paste",
            price: 129,
            quantity: 1,
          },
        ],
        deliveryFee: 60,
        discount: 0,
        subTotal: 866,
        total: 926,
      },
      promotionalDiscount: 0,
    };
  },
  computed: {
    // ...mapGetters({
    //     loading: "order/loading",
    // }),
    shippingAddress() {
      return this.order.shipping;
    },
    formatedAddress() {
      if (this.shippingAddress) {
        const shippingAddress = this.shippingAddress;
        return `${shippingAddress.shippingAddress} ${
          shippingAddress.shippingSubDistrict || ""
        } ${shippingAddress.shippingDistrict || ""} ${
          shippingAddress.shippingProvince
        } ${shippingAddress.shippingPostcode}`;
      }
      return "";
    },
    RTP() {
      return this.$route.params.id;
    },
    // order() {
    //   return {
    //     shipping: {
    //       address: "168/22 mo. 5 Prakret Nonthaburi 11120",
    //     },
    //     productList: [
    //       {
    //         productName: "Turkey",
    //         price: 199,
    //         quantity: 3,
    //       },
    //       {
    //         productName: "Crushed Olives Naples Style",
    //         price: 140,
    //         quantity: 1,
    //       },
    //       {
    //         productName: "Spicy Red Snow Crab Paste",
    //         price: 129,
    //         quantity: 1,
    //       },
    //     ],
    //     deliveryFee: 60,
    //     discount: 0,
    //     subTotal: 866,
    //     total: 926,
    //   };
    // },
  },
  watch: {
    selectedPaymentMethod: {
      immediate: false,
      handler(value) {
        if (value === "Amex") {
          this.$store.dispatch("order/configureAmex");
        }
      },
    },
  },
  mounted() {
    console.log(this.$q.platform);
    console.log("get rtp", this.RTP);
    this.loadRequestToPay();
  },
  methods: {
    async loadRequestToPay() {
      let rtp;

      try {
        rtp = await this.$services.requestToPay.getRequestToPay(this.RTP);
        console.log({ rtp });

        if (rtp == null || rtp == undefined) {
          this.sessionExpire = true;
          return;
        }

        // get current time
        const response = await API.get("saletoolapi", "/time");

        if (response["time"] > rtp.expirationTime) {
          console.log("session expire");
          this.sessionExpire = true;
          return;
        }

        // await this.$services.authentication.getIdToken();
        let order = await this.$services.orders.getOrderById(rtp.orderID, "");

        console.log({ order });
        if (order.payment) {
          if (order.payment.isPaid == true) {
            console.log("session expire");
            this.sessionExpire = true;
            return;
          }
        }

        const apikey = await this.$services.authentication.getApikey();
        order = await this.$services.calculatePrice.getResolveCoupon(
          order,
          apikey.key
        );

        console.log({ order });

        this.order = order;
        this.order.orderId = rtp.orderID;

        this.promotionalDiscount =
          (order.bogoDiscount || 0) + (order.cartDiscount || 0);

        this.loading = false;
        // throw Error("Test loadRequestToPay error");
      } catch (error) {
        console.error(error);
        Sentry.captureException(error);
        this.isRequestToPayError = true;
        this.loading = false;
        return;
      }
    },
    async onContinue() {
      console.log("onContinue");
      const orderId = this.order.orderId;
      switch (this.selectedPaymentMethod) {
        case "Credit/Debit card":
          {
            try {
              this.paymentLoading = true;
              console.log("pay by Credit/Debit card");
              const response = await this.$store.dispatch(
                "order/payByCreditCard",
                orderId
              );
              console.log(`response`, response);
              const formPayment = this.$refs.payment;
              console.log(paymentComponents[this.selectedPaymentMethod]);

              formPayment.setInfo(response);
              formPayment.submit();

              setTimeout(() => {
                this.paymentLoading = false;
              }, 3000);
            } catch (error) {
              console.warn(error);
              this.paymentLoading = false;
            }
          }
          break;
        case "Amex":
          {
            try {
              this.paymentLoading = true;
              console.log("pay by Amex");
              console.log(paymentComponents[this.selectedPaymentMethod]);
              const response = await this.$store.dispatch(
                "order/payByAmex",
                orderId
              );
              console.log(response);
              if (window.Checkout) {
                window.Checkout.configure({
                  session: {
                    id: response.session.id,
                  },
                  interaction: {
                    merchant: {
                      name: response.merchant, //required
                    },
                  },
                });
                window.Checkout.showPaymentPage();
              } else {
                throw new Error("Cannot connect AMEX");
              }

              setTimeout(() => {
                this.paymentLoading = false;
              }, 3000);
            } catch (error) {
              console.warn(error);
              this.paymentLoading = false;
            }
          }
          break;
        case "Vplus Wallet":
          {
            console.log("pay by Vplus Wallet");

            this.$q
              .dialog({
                // title: "Place order success",
                // message: `Order: ${order.orderId}`,
                cancel: true,
                persistent: true,
                component: PayVplus,
                store: this.$store,
                orderId,
                vmemberId: this.memberId,
                vphone: this.phone,
                // props forwarded to your custom component
                // parent: {
                // text: rtp.id,
                // ...more..props...
                // },
              })
              .onOk(async ({ phone }) => {
                console.log("OK");
                try {
                  this.paymentLoading = true;

                  //   this.memberId = memberId;
                  this.phone = phone;

                  const payload = {
                    orderId,
                    mobile: phone,
                  };
                  const response = await this.$store.dispatch(
                    "order/payByWallet",
                    payload
                  );

                  console.log({ response });

                  if (response.statusCode == "00") {
                    // this.$q.dialog({
                    //   title: "Vplus Wallet",
                    //   message: `Request to pay will be sent soon.`,
                    // });
                    const formRef = this.$refs["payment"];
                    const { data } = response;
                    console.log("formRef", formRef);
                    formRef.setInfo(data);
                    formRef.submit();
                  } else {
                    this.$q.dialog({
                      title: "Error",
                      message: response.message,
                    });
                  }

                  this.paymentLoading = false;
                } catch (error) {
                  console.warn(error);
                  this.paymentLoading = false;
                }

                // clear cart
                // this.$store.dispatch("cart/clearBasket");
              })
              .onCancel(() => {
                // console.log('Cancel')
              })
              .onDismiss(() => {
                // console.log('I am triggered on both OK and Cancel')
              });

            //             let isError = false;
            //             if (this.isValidPhone && this.isValidID) {
            //               console.log("Already to pay");
            //               const payload = {
            //                 orderId: this.orderId,
            //                 memberId: this.vplusData.memberId,
            //                 mobile: this.vplusData.phoneNumber,
            //               };
            //               const response = await this.$store.dispatch(
            //                 "order/payByWallet",
            //                 payload
            //               );
            //               console.log(response);
            //               switch (response.statusCode) {
            //                 case 500:
            //                   {
            //                     this.dialogVplusWallet.show = true;
            //                     this.dialogVplusWallet.message = response.message;
            //                     isError = true;
            //                   }
            //                   break;
            //                 case 200:
            //                   {
            //                     this.dialogVplusWallet.show = true;
            //                     this.dialogVplusWallet.message = `Please check you Vplus wallet application\nfor approval of the wallet transaction.
            // `;
            //                     this.dialogVplusWallet.submessage = `If the notification doesn't show up\nyou may need to restart the app.`;
            //                   }
            //                   break;
            //                 default:
            //                   break;
            //               }
            //             } else {
            //               return;
            //             }
          }
          break;
        case "Other": {
          try {
            this.paymentLoading = true;
            console.log("pay by Other");
            const response = await this.$store.dispatch(
              "order/payByOther",
              orderId
            );
            console.log(`response`, response);
            const formPayment = this.$refs.payment;
            console.log(paymentComponents[this.selectedPaymentMethod]);

            formPayment.setInfo(response);
            formPayment.submit();

            setTimeout(() => {
              this.paymentLoading = false;
            }, 3000);
          } catch (error) {
            console.warn(error);
            this.paymentLoading = false;
          }
        }
      }
    },
  },
  onCloseDialogVplusWallet() {
    this.dialogVplusWallet.show = !this.dialogVplusWallet.show;
    this.dialogVplusWallet.message = undefined;
    this.dialogVplusWallet.submessage = undefined;
  },
};
</script>

<style scoped>
.my-card {
  min-width: 360px;
}

.my-card-mobile {
  width: 100vw;
  height: 100vh;
}

.no-bold {
  font-weight: normal;
}
</style>
